import { render, staticRenderFns } from "./FaqTabs.vue?vue&type=template&id=2f1469ae&scoped=true"
import script from "./FaqTabs.vue?vue&type=script&lang=js"
export * from "./FaqTabs.vue?vue&type=script&lang=js"
import style0 from "./FaqTabs.vue?vue&type=style&index=0&id=2f1469ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1469ae",
  null
  
)

export default component.exports